module.exports = __webpack_public_path__ + "img/1783.d67cb7f2.gif";